import React from "react";
import style from "css/loading.module.css";
import { Spin } from "antd";

/**
 * 파일명: Loading.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 공통 loading 컴포넌트
 */
function Loading() {
  return (
    <div className={style.container}>
      <Spin />
    </div>
  );
}

export default Loading;
